<!-- <div class="w-full pull-left" style="min-height: 600px;"> -->

<div class="w-100 float-left min-h2 relative">
    <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center">

        <img src="./assets/img/load.gif" alt="loading" width="80px">

    </div>
</div>
<!-- </div> -->


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/loader.component.html